import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { PORT } from "../../config";
import { notify } from "react-notify-toast";
import DeletePopup from "./ConfirmationBox";
import { addDays } from "date-fns";
import { connect } from "react-redux";

import "react-datepicker/dist/react-datepicker.css";
import "./UserProfile.css";
import { getStates, handleLogErrorToSlack } from "../../Helper";
import ImageCrops from "./ImageCrops";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormField from "../../Components/FormField/FormField";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import { API } from "../../API";
import { CircularProgress } from "@mui/material";

const URL = PORT;
let fileType;

const States = getStates().sort();

export class ECECCheckForm extends Component {
  constructor(props) {
    super(props);

    if (!this.props.user) {
      window.location = "/login";
    }

    this.state = {
      deleteEcecPopup: false,
      filetype: true,
      file: null,
      preview: null,
      show: false,
      borderRadius: 0,
      width: 300,
      height: 200,
      scale: 1,
      image: "",
      allowZoomOut: false,
      showPopup: false,
      isLoading: false
    };
  }

  handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });
  };

  uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  handleECECFileChange = async () => {
    var isValidFile = false;
    let ececFile = this.uploadECEC.files[0];
    let filesize = this.uploadECEC.files[0].size >> 10
    isValidFile = this.validateFile(ececFile, "ecec");
    if (isValidFile) {
      this.setState({
        image: ececFile,
      });
      await this.saveFile(ececFile);
    }
  };

  // unused?
  fileIsPdf = () => {
    let ececFile = this.uploadECEC.files[0];
    this.setState({ image: this.uploadECEC.files[0] });

    let isPdf = true;
    let filesplit = ececFile.name.split(".");
    let filetype = filesplit[1];
    if (filetype !== "pdf") {
      isPdf = false;
    }
    return isPdf;
  };

  validateFile = (file, filename) => {
    let isValid = false;
    if (file !== null && file !== undefined) {
      isValid = true;
    }
    return isValid;
  };

  deleteFile = (isDelete, fileName, popupStatus) => {
    var popUpState = "delete" + fileName + "Popup";
    if (isDelete) {
      notify.show("File deleted successfully");
      this.props.handleStateChange("ecec_filename", null);
      this.props.handleStateChange("ecec_url", null);
    }
    this.setState({ [popUpState]: popupStatus });
  };
  onFileUpload = (filename, url) => {
    this.props.handleStateChange("ecec_filename", filename);
    this.props.handleStateChange("ecec_url", url);
  };
  // is this actually being used?
  saveFile = async (file) => {
    // let fileParts = file.name.split(".")
    // let fileType = fileParts[1]
    // let fileName = "ecec"

    // const [preFileName] = file.name.split(".");
    this.setState({
      isLoading: true
    });
    const fileName = 'ecec'

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  }

  onImageCrop = (filename, url) => {
    this.props.handleStateChange("ecec_filename", filename);
    this.props.handleStateChange("ecec_url", url);
  };

  togglePopup = () => {
    this.setState({ showPopup: !this.state.showPopup });
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="auth-text-top mb-5">
            {/* ECEC Issuing State */}
            <FormDropdown
              label="First AID Issuing State"
              id="ecec_issuing_state"
              name="ecec_issuing_state"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state.ecec_issuing_state || ""}
              required
            >
              <option disabled value="">
                Please Select
              </option>
              {States.map((place) => {
                return <option key={place}>{place}</option>;
              })}
            </FormDropdown>

            {/* ECECC Number */}
            <FormField
              label="Card Number"
              id="ecec_number"
              name="ecec_number"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state.ecec_number}
              maxLength="120"
              required
              placeholder="First AID Number"
            />

            {/* ECEC Expiry Date */}
            <FormDatePicker
              label="Expiry Date"
              id="ecec_expiry"
              selected={this.props.state.ecec_expiry}
              placeholderText={new Date()
                .toLocaleDateString()
                .split(/\//)
                .join("-")}
              showYearDropdown
              showMonthDropdown
              isClearable
              showPopperArrow={false}
              minDate={addDays(new Date(), 0)}
              dropdownMode="select"
              dateFormatCalendar="MMMM"
              dateFormat="dd-MM-yyyy"
              yearDropdownItemNumber={10}
              scrollableYearDropdown
              value={this.props.state.ecec_expiry}
              onChange={this.props.handleDateChange}
              required
            />

            <FormField
              label="Upload Card"
              id="flWWCC"
              name="userWWCC"
              disabled
              required
              placeholder={
                this.props.state.ecec_filename ||
                "Please add a PDF copy of your USI form"
              }
              header={
                <>
                  {this.state.ecec_status ? (
                    <HoverIcon
                      icon="check circle"
                      color="green"
                      text="This document has been verified!"
                    />
                  ) : (
                    <HoverIcon
                      icon="check circle"
                      color="grey"
                      text="This document has not been verified yet!"
                    />
                  )}
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="Please upload a file less than 600KB."
                  />
                </>
              }
              sideButton={{
                id: "btnUpload_wwcc",
                label: "Upload",
                type: "button",
                onClick: () => this.uploadDocument("ecec"),
                disabled: this.props.state.ecec_url || this.state.isLoading,
              }}
              footer={
                this.props.state.ecec_filename ? (
                  <div className="text-left d-flex">
                    <a href={`/NavigateToFileViewer?fileurl=${this.props.state.ecec_url}`} target='_blank'>
                      <p className="uploaded-file-name mt-1 ml-1">
                        {this.props.state.ecec_filename}
                      </p>
                    </a>
                    <i
                      className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                      onClick={() => this.setState({ deleteEcecPopup: true })}
                    ></i>
                    {this.state.deleteEcecPopup && (
                      <DeletePopup
                        togglePopup={(isDelete) =>
                          this.deleteFile(isDelete, "Ecec", false)
                        }
                      />
                    )}
                  </div>
                ) : (
                  ""
                )
              }
            >
              {
                this.state.isLoading && (
                  <CircularProgress />
                )
              } 
              <input
                type="file"
                id="ecec"
                name="ecec"
                onChange={() => this.handleECECFileChange()}
                ref={(ref) => {
                  this.uploadECEC = ref;
                }}
                style={{ display: "none" }}
                accept="image/*, .pdf"
              />
            </FormField>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
export default connect(mapStateToProps)(ECECCheckForm);
